import React, { Component } from 'react';
import { withStyles } from '@glu/theming';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { JSSClasses } from '../../proptypes/jss-prop-types';

/* istanbul ignore next */
const styles = ({ palette: { primary } }) => ({
  text: {
    wordBreak: 'break-word'
  },
  bold: {
    '& strong': {
      fontWeight: 'bold'
    }
  },
  italic: {
    '& em': {}
  },
  link: {
    '& a': {
      color: primary.normal
    }
  },
  strikethrough: {
    '& s': {}
  },
  underline: {
    '& u': {}
  }
});

/* eslint-disable react/no-danger */
/* eslint-disable react/prefer-stateless-function */
/** @description Refs are not available stateless components.
 * For 'react-to-print' to work only Class based components can be printed */
export class DangerousContentComponent extends Component {
  render() {
    const {
      classes: { bold, italic, link, strikethrough, text, underline },
      content
    } = this.props;
    return (
      <span
        className={classnames(text, bold, italic, link, strikethrough, underline)}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }
}

DangerousContentComponent.propTypes = {
  classes: JSSClasses,
  content: PropTypes.string
};

DangerousContentComponent.defaultProps = {
  classes: {},
  content: ''
};

export default withStyles(styles)(DangerousContentComponent);
